import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'widget.title': {
    defaultMessage: 'Interactive Walkthrough',
    id: 'g9UFWQ',
  },
  'widget.subtitle': {
    defaultMessage:
      'In just a matter of minutes, experience the value of <strong>IBM Cloud Pak for Network Automation (CPNA)</strong>',
    id: 'WkNMZw',
  },
  'template.nextSteps': { defaultMessage: 'Next Steps', id: 'xe05Cm' },
  'template.menu': { defaultMessage: 'Menu', id: 'tKMlOc' },
  'template.complete': { defaultMessage: 'Complete', id: 'U78NhE' },
  'scenarioA.title': { defaultMessage: 'App Integration', id: 'ce/bnO' },
  'scenarioA.stepA1.title': {
    defaultMessage: 'Creating a VPC',
    id: 'v9zr3S',
  },
  'scenarioA.stepA1.body': {
    defaultMessage:
      '<p>In this brief demo, you will be using the wired portal to create a virtual private cloud. The wired Portal is a web-based interface which demonstrates how clients can build custom web interfaces optimized for their needs by leveraging the full power of CP4NA. You will see how CP4NA’s automation combined with our wizard driven portal can remove all of the complexities and manual operations when it comes to delivering cloud services over SDWAN to your customer sites.</p>',
    id: 'Xl7bHp',
  },
  'scenarioA.stepA1.alt': {
    defaultMessage:
      'Cloud Pak For Network Automation homepage screen with Wired Portal option highlighted',
    id: '5y+Pmz',
  },
  'scenarioA.stepA1.nextSteps': {
    defaultMessage: 'Click <strong>Wired Portal</strong>',
    id: '4JbFtX',
  },
  'scenarioA.stepA2.title': {
    defaultMessage: 'Onboard your cloud account',
    id: 'j4YnoS',
  },
  'scenarioA.stepA2.body': {
    defaultMessage:
      '<p>CP4NA’s simplified overview page shows you a quick summary of every one of your current onboarded cloud accounts. How many regions are active on those accounts and the status of their VPCs.</p>',
    id: 'dtGStF',
  },
  'scenarioA.stepA2.alt': {
    defaultMessage:
      'Onboarding a cloud account on Cloud Pak For Network Automation screen with SDN-AWS option highlighted',
    id: 'nnDjd7',
  },
  'scenarioA.stepA2.nextSteps': {
    defaultMessage: 'Click <strong>SDN-AWS</strong>',
    id: 'NbpdwT',
  },
  'scenarioA.stepA3.title': {
    defaultMessage: 'VPC Overview Page',
    id: 'ou67Yd',
  },
  'scenarioA.stepA3.body': {
    defaultMessage:
      '<p>On this page you can view all of the configuration of the currently deployed VPC’s, create new ones or even connect 2 VPC’s together! </p>',
    id: '6LGFfN',
  },
  'scenarioA.stepA3.alt': {
    defaultMessage:
      'SDN-AWS Overview page on Cloud Pak For Network Automation screen with Create VPC option highlighted',
    id: 'dfveF2',
  },
  'scenarioA.stepA3.nextSteps': {
    defaultMessage: 'Click <strong>Create VPC</strong>',
    id: 'ShnKJt',
  },
  'scenarioA.stepA4.title': {
    defaultMessage: 'Specify VPC details',
    id: 'UcmC/1',
  },
  'scenarioA.stepA4.body': {
    defaultMessage:
      '<p>You are now ready to create a VPC and all that is required of you to do that is to fill in the missing fields with your information.</p>',
    id: 'D0InGF',
  },
  'scenarioA.stepA4.bullet1': {
    defaultMessage: 'Define VPC',
    id: 'Gc8HJK',
  },
  'scenarioA.stepA4.bullet2': {
    defaultMessage: 'Add Subnets',
    id: '3O6d5b',
  },
  'scenarioA.stepA4.bullet3': {
    defaultMessage: 'Choose an SDWAN controller #',
    id: 'yeUuDR',
  },
  'scenarioA.stepA4.alt': {
    defaultMessage:
      'Entering the VPC details on Cloud Pak For Network Automation screen with Create VPC option highlighted',
    id: 'ntkHN5',
  },
  'scenarioA.stepA4.nextSteps': {
    defaultMessage: 'Click <strong>Create VPC</strong>',
    id: 'ShnKJt',
  },
  'scenarioA.stepA5.title': {
    defaultMessage: 'VPC Created',
    id: 'brFlz1',
  },
  'scenarioA.stepA5.body': {
    defaultMessage:
      '<p>You can now see your VPC creation has been successfully initiated. This process on average only takes up to 10 minutes but instead of waiting around here we can view the execution flow in the CP4NA main UI. </p>',
    id: 'eqVbLZ',
  },
  'scenarioA.stepA5.alt': {
    defaultMessage:
      'Provisioning VPC on Cloud Pak For Network Automation screen with Profile icon option highlighted',
    id: 'UOscyK',
  },
  'scenarioA.stepA5.nextSteps': {
    defaultMessage: 'Click <strong>Profile Icon</strong>',
    id: '2QV5xR',
  },
  'scenarioA.stepA6.title': {
    defaultMessage: 'CP4NA Assembly Designer',
    id: 'Q66vl5',
  },
  'scenarioA.stepA6.body': {
    defaultMessage:
      '<p>This is the CP4NA’s assembly designer. This allows you to see all of the recent assembly instances. As you can see our newly created instance is here.</p>',
    id: '2f3O5x',
  },
  'scenarioA.stepA6.alt': {
    defaultMessage:
      'Assembly designer overview on Cloud Pak For Network Automation screen with Open option highlighted',
    id: '7fHVEt',
  },
  'scenarioA.stepA6.nextSteps': {
    defaultMessage: 'Click <strong>Open</strong>',
    id: 'ixr6N0',
  },
  'scenarioA.stepA7.title': {
    defaultMessage: 'Execution View',
    id: 'NS0Oxb',
  },
  'scenarioA.stepA7.body': {
    defaultMessage:
      '<p>This Execution view shows a Gantt chart of individual steps that are run within the CPNA intent engine, along with their dependencies. The status of each step is color-coded. You can see here how all the information you provided through the wired portal is being used here. There is no further manual processes required. CP4NA takes care of the rest for you. </p>',
    id: 'q/BJPs',
  },
  'scenarioA.stepA7.alt': {
    defaultMessage:
      'Assembly designers execution overview of the VPC deployment on Cloud Pak For Network Automation screen',
    id: 'Tm0iVW',
  },
  'scenarioA.stepA8.title': {
    defaultMessage: 'Your VPC is now active',
    id: 'prj0nA',
  },
  'scenarioA.stepA8.body': {
    defaultMessage:
      '<p>Congratulations - you have successfully deployed a new active instance of a VPC. Imagine deploying lots of such instances across a region or several regions at a single click!</p>',
    id: 'YJvror',
  },
  'scenarioA.stepA8.alt': {
    defaultMessage: 'Man working on a laptop',
    id: 'bT0jIk',
  },
});

export type messageType = keyof typeof messages;
